module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _vm._v("CHRONOLOGY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1853")]), _vm._v(" Birth of Edward Fitzgerald at “Glenmary” farm near Rockville in Montgomery County, Maryland.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1858")]), _vm._v(" Birth of Anthony D. Sayre in Tuskegee, Alabama.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1860")]), _vm._v(" Birth of Mary (“Mollie”) McQuillan in St. Paul, Minnesota. Birth of Minnie Buckner Machen in Eddyville, Kentucky.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("June 1884")]), _vm._v(" Marriage of Anthony Sayre and Minnie Machen at “Mineral Mount,” near Eddyville, Kentucky.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("12 February 1890")]), _vm._v(" Marriage of Edward Fitzgerald and Mollie McQuillan in Washington, D.C.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("24 September 1896")]), _vm._v(" Birth of Francis Scott Key Fitzgerald at 481 Laurel Avenue, St. Paul, Minnesota.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("April 1898")]), _vm._v(" After failure of his St. Paul furniture factory, Edward Fitzgerald takes job as salesman with Procter & Gamble in Buffalo, New York.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("24 July 1900")]), _vm._v(" Birth of Zelda Sayre at South Street, Montgomery, Alabama.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("January 1901")]), _vm._v(" Fitzgerald family moves to Syracuse, New York.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("21 July 1901")]), _vm._v(" Birth of Annabel Fitzgerald.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("September 1903")]), _vm._v(" Fitzgerald family moves back to Buffalo.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1907")]), _vm._v(" Sayre family moves to 6 Pleasant Avenue, Zelda’s home until her marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("March 1908")]), _vm._v(" Edward Fitzgerald loses his job.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("July 1908")]), _vm._v(" The Fitzgerald family returns to St. Paul. FSF enters St. Paul Academy in September.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1909")]), _vm._v(" Judge Sayre of the City Court is appointed associate justice of the Supreme Court of Alabama.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("October 1909")]), _vm._v(" Publication of “The Mystery of The Raymond Mortgage” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("St. Paul Academy Now & Then")]), _vm._v("—FSF’s first appearance in print.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("August 1911")]), _vm._v(" FSF writes his first produced play, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Girl from Lazy J,")]), _vm._v(" in St. Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("September 1911")]), _vm._v(" FSF enters Newman School, Hackensack, New Jersey.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("August 1912")]), _vm._v(" Production of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Captured Shadow")]), _vm._v(" in St. Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("November 1912")]), _vm._v(" FSF meets Father Sigourney Fay and Shane Leslie.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("August 1913")]), _vm._v(" Production of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Coward”")]), _vm._v(" in St. Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("September 1913")]), _vm._v(" FSF enters Princeton University with Class of 1917; meets Edmund Wilson ’16 and John Peale Bishop ’17.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("September 1914")]), _vm._v(" Production of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Assorted Spirits")]), _vm._v(" in St. Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Fall 1914")]), _vm._v(" FSF contributes to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Princeton Tiger.")]), _vm._v(" Zelda enters Sidney Lanier High School.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("December 1914")]), _vm._v(" Production of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fie! Fie! Fi-Fi,")]), _vm._v(" FSFs first Princeton Triangle Club show, for which he provided the book and lyrics.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 January 1915")]), _vm._v(" FSF meets Ginevra King in St. Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("April 1915")]), _vm._v(" “Shadow Laurels,” a play, is FSF’s first publication in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nassau Literary Magazine.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("June 1915")]), _vm._v(" FSF’s “The Ordeal,” later rewritten as “Benediction,” is his first story published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Nassau Literary Magazine.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("28 November 1915")]), _vm._v(" FSF drops out of Princeton for remainder of junior year.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("December 1915")]), _vm._v(" Production by Triangle Club of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Evil Eye,")]), _vm._v(" for which FSF wrote the lyrics.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("September 1916")]), _vm._v(" FSF returns to Princeton as member of Class of 1918.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("December 1916")]), _vm._v(" Production of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Safety First")]), _vm._v(" by Triangle Club, for which FSF wrote the lyrics.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("26 October 1917")]), _vm._v(" FSF receives commission as infantry 2nd lieutenant.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("20 November 1917")]), _vm._v(" FSF reports to Fort Leavenworth, Kansas; begins novel “The Romantic Egotist.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("End of February 1918")]), _vm._v(" FSF completes first draft of “The Romantic Egotist” on leave at Princeton; submits novel to Scribners.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("15 March 1918")]), _vm._v(" FSF reports to Camp Taylor, Louisville, Kentucky.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("April 1918")]), _vm._v(" FSF transferred to Camp Gordon, Georgia.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("May 1918")]), _vm._v(" Zelda graduates from Sidney Lanier High School.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("June 1918")]), _vm._v(" FSF reports to Camp Sheridan near Montgomery, Alabama.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("July 1918")]), _vm._v(" FSF and Zelda meet at country club dance in Montgomery.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("August 1918")]), _vm._v(" Scribners declines “The Romantic Egotist”; revised typescript rejected in October.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("26 October 1918")]), _vm._v(" FSF reports to Camp Mills, Long Island, to await embarkation; war ends before unit sent overseas.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Late November 1918")]), _vm._v(" FSF returns to Camp Sheridan; becomes aide-de-camp to General J. A. Ryan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("February 1919")]), _vm._v(" FSF discharged from army. Planning to marry Zelda, he goes to New York and works for the Barron Collier advertising agency; lives in room at 200 Claremont Avenue and tries unsuccessfully to sell short stories to magazines.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Spring 1919")]), _vm._v(" FSF visits Montgomery in April, May, and June as Zelda remains reluctant to commit herself to marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("June 1919")]), _vm._v(" Zelda breaks engagement.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("July–August 1919")]), _vm._v(" FSF quits advertising job and returns to St. Paul; rewrites novel while living with parents at 599 Summit Avenue.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("September 1919")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Smart Set")]), _vm._v(" publishes “Babes in the Woods,” FSF’s first commercial story sale.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("16 September 1919")]), _vm._v(" Maxwell Perkins of Scribners accepts novel, now titled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This Side of Paradise.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("November 1919")]), _vm._v(" FSF becomes client of Harold Ober at Reynolds agency. First sale to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Saturday Evening Post:")]), _vm._v(" “Head and Shoulders.” FSF visits Zelda in Montgomery.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("November 1919–February 1920")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Smart Set")]), _vm._v(" publishes “The Debutante,” “Porcelain and Pink,” “Benediction,” and “Dalyrimple Goes Wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mid-January 1920")]), _vm._v(" FSF lives in boarding house at 2900 Prytania Street in New Orleans, where he stays less than a month. Engagement to Zelda resumes during his visits to Montgomery.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("March-May 1920")]), _vm._v(" “Myra Meets His Family,” “The Camel’s Back,” “Bernice Bobs Her Hair,” “The Ice Palace,” and “The Offshore Pirate” appear in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Saturday Evening Post.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("26 March 1920")]), _vm._v(" Publication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This Side of Paradise.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 April 1920")]), _vm._v(" Marriage of FSF and Zelda at rectory of St. Patrick’s Cathedral in New York. Honeymoon at Biltmore Hotel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("May–September 1920")]), _vm._v(" Fitzgeralds rent house at Westport, Connecticut, where FSF works on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Beautiful and Damned.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("July 1920")]), _vm._v(" Publication of “May Day” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Smart Set.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Summer 1920")]), _vm._v(" Fitzgeralds drive to Montgomery; return to Westport by mid-August.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("10 September 1920")]), _vm._v(" Publication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Flappers and Philosophers:")]), _vm._v(" FSF’s first short-story collection.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("October 1920–April 1921")]), _vm._v(" Fitzgeralds take apartment at 38 West 59th Street, New York City.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3 May–July 1921")]), _vm._v(" Fitzgeralds make first trip to Europe; sail to England then visit France and Italy. Return home and visit Montgomery.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("August 1921")]), _vm._v(" Fitzgeralds travel to St. Paul; rent house at Dellwood, White Bear Lake.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("September 1921–March 1922")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Beautiful and Damned")]), _vm._v(" serialized in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Metropolitan Magazine.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("26 October 1921")]), _vm._v(" Birth of daughter Scottie.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("November 1921–June 1922")]), _vm._v(" Fitzgeralds rent house at 646 Goodrich Avenue, St. Paul.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4 March 1922")]), _vm._v(" Publication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Beautiful and Damned.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Summer 1922")]), _vm._v(" Fitzgeralds move to White Bear Yacht Club. He works on his play, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Vegetable.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("June 1922")]), _vm._v(" Publication of “The Diamond as Big as the Ritz” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Smart Set.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("22 September 1922")]), _vm._v(" Publication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tales of the Jazz Age:")]), _vm._v(" FSF’s second collection of short stories.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mid-October 1922–April 1924")]), _vm._v(" Fitzgeralds rent house at 6 Gateway Drive in Great Neck, Long Island. Friendship with Ring Lardner.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("December 1922")]), _vm._v(" Publication of “Winter Dreams” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Metropolitan Magazine.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("27 April 1923")]), _vm._v(" Publication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Vegetable.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("19 November 1923")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Vegetable")]), _vm._v(" fails at tryout in Atlantic City, New Jersey.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5 April 1924")]), _vm._v(" “How to Live on $36,000 a Year” published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Saturday Evening Post.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mid-April 1924")]), _vm._v(" Fitzgeralds sail for France.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("May 1924")]), _vm._v(" Fitzgeralds visit Paris, then leave for Riviera; stop at Grimm’s Park Hotel in Hyères and setde in June at Villa Marie, Valescure, St. Raphaël.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("June 1924")]), _vm._v(" Publication of “Absolution” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The American Mercury.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("July 1924")]), _vm._v(" ZF becomes involved with French naval aviator Edouard Jozan. Publication of‘“The Sensible Thing’” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Liberty.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Summer 1924")]), _vm._v(" Fitzgeralds meet Gerald and Sara Murphy at Cap d’Antibes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Summer–Fall 1924")]), _vm._v(" FSF writes "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Great Gatsby.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ca. 10 October 1924")]), _vm._v(" FSF writes to Maxwell Perkins about promising American writer, Ernest Hemingway.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("October 1924—February 1925")]), _vm._v(" Fitzgeralds at Hôtel des Princes, Rome, where FSF revises galleys of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Great Gatsby.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("February 1925")]), _vm._v(" Fitzgeralds travel to Capri; at Hotel Tiberio.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("10 April 1925")]), _vm._v(" Publication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Great Gatsby.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Late April 1925")]), _vm._v(" Fitzgeralds move to Paris; rent apartment at 14 rue de Tilsitt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("May 1925")]), _vm._v(" FSF meets Ernest Hemingway in Dingo bar, Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Summer 1925")]), _vm._v(" FSF starts planning Francis Melarky version of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tender Is the Night.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("August 1925")]), _vm._v(" Fitzgeralds leave Paris for month at Antibes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("January 1926")]), _vm._v(" ZF takes “cure” at Salies-de-Béarn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("January and February 1926")]), _vm._v(" Publication of “The Rich Boy” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Redbook Magazine.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("February 1926")]), _vm._v(" Play version of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Great Gatsby,")]), _vm._v(" by Owen Davis, produced on Broadway.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("26 February 1926")]), _vm._v(" Publication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("All the Sad Young Men:")]), _vm._v(" FSF’s third short-story collection.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Early March 1926")]), _vm._v(" Fitzgeralds return to Riviera and rent Villa Paquita at Juan-les-Pins.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("May 1926")]), _vm._v(" Hemingways join Murphys and Fitzgeralds on Riviera. Fitzgeralds move to Villa St. Louis, Juan-les-Pins, where they remain until end of 1926. “How to Waste Material: A Note on My Generation” is published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Bookman.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("December 1926")]), _vm._v(" Fitzgeralds return to America.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("January 1927")]), _vm._v(" Fitzgeralds go to Hollywood; FSF writes “Lipstick” (unproduced) for United Artists. They meet Lois Moran.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("March 1927–March 1928")]), _vm._v(" Fitzgeralds rent “Ellerslie,” near Wilmington, Delaware. ZF begins ballet lessons.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("April 1928")]), _vm._v(" Fitzgeralds return to Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("April–August 1928")]), _vm._v(" Fitzgeralds rent apartment at 58 rue de Vaugirard, Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("28 April 1928")]), _vm._v(" Publication of “The Scandal Detectives” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Saturday Evening Post:")]), _vm._v(" first of eight-story Basil Duke Lee series.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mid-summer 1928")]), _vm._v(" ZF begins ballet training with Lubov Egorova in Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7 October 1928")]), _vm._v(" Fitzgeralds return to America.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("October 1928–March 1929")]), _vm._v(" Fitzgeralds at “Ellerslie.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2 March 1929")]), _vm._v(" Publication of “The Last of the Belles” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Saturday Evening Post.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("March 1929")]), _vm._v(" Fitzgeralds return to Europe; travel from Genoa along Riviera, then to Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("June 1929")]), _vm._v(" Fitzgeralds leave Paris for Riviera; rent Villa Fleur des Bois, Cannes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("July 1929")]), _vm._v(" ZF’s “The Original Follies Girls” published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("College Humor.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("October 1929")]), _vm._v(" Fitzgeralds return by car to Paris by way of Provence; take apartment at 10 rue Pergolese.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("February 1930")]), _vm._v(" FSF and ZF travel to North Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5 April 1930")]), _vm._v(" Publication of “First Blood” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Saturday Evening Post:")]), _vm._v(" first of five-story Josephine Perry series.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("23 April-11 May 1930")]), _vm._v(" Suffering her first emotional breakdown, ZF is hospitalized at Malmaison Clinic outside Paris; she discharges herself.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("22 May 1930")]), _vm._v(" ZF is hospitalized at Val-Mont Clinic in Glion, Switzerland.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5 June 1930")]), _vm._v(" ZF enters Prangins clinic at Nyon, Switzerland.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Summer and Fall 1930")]), _vm._v(" FSF lives in Switzerland.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("11 October 1930")]), _vm._v(" Publication of “One Trip Abroad” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Saturday Evening Post.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("26 January 1931")]), _vm._v(" Death of Edward Fitzgerald. FSF returns alone to America to attend burial; reports to Sayres about ZE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("21 February 1931")]), _vm._v(" Publication of “Babylon Revisited” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Saturday Evening Post.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("July 1931")]), _vm._v(" Fitzgeralds spend two weeks at Lake Annecy, France.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("15 August 1931")]), _vm._v(" “Emotional Bankruptcy” published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Saturday Evening Post.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("15 September 1931")]), _vm._v(" ZF released from Prangins. Fitzgeralds return to America.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("September 1931–Spring 1932")]), _vm._v(" Fitzgeralds rent house at 819 Felder Avenue in Montgomery. FSF goes to Hollywood alone to work on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Red-Headed Woman")]), _vm._v(" for Metro-Goldwyn-Mayer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("17 November 1931")]), _vm._v(" Death of Judge Sayre.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("12 February 1932")]), _vm._v(" ZF suffers second collapse; enters Phipps Psychiatric Clinic of Johns Hopkins Hospital in Baltimore.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("March 1932")]), _vm._v(" ZF completes first draft of her novel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Save Me the Waltz,")]), _vm._v(" while at Phipps Clinic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("20 May 1932–November 1933")]), _vm._v(" FSF rents “La Paix” at Towson outside Baltimore.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("26 June 1932")]), _vm._v(" ZF discharged from Phipps; joins family at “La Paix.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("October 1932")]), _vm._v(" “Crazy Sunday” published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The American Mercury.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7 October 1932")]), _vm._v(" Publication of ZF’s novel, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Save Me the Waltz.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("26 June–1 July 1933")]), _vm._v(" ZF’s play, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scandalabra,")]), _vm._v(" produced by Vagabond Junior Players in Baltimore.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("11 October 1933")]), _vm._v(" “Ring,” FSF’s memorial tribute to Lardner, is published in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Republic.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("December 1933")]), _vm._v(" FSF rents house at 1307 Park Avenue, Baltimore.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("January-April 1934")]), _vm._v(" Serialization of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tender is the Night")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Scribner’s Magazine.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("12 February 1934")]), _vm._v(" ZF’s third collapse; returns to Phipps Clinic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("March 1934")]), _vm._v(" ZF transferred to Craig House, Beacon, New York.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("29 March–30 April 1934")]), _vm._v(" ZF’s art exhibition in New York.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("12 April 1934")]), _vm._v(" Publication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tender Is the Night.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("19 May 1934")]), _vm._v(" ZF transferred to Sheppard-Pratt Hospital outside Baltimore.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("February 1935")]), _vm._v(" FSF at Oak Hall Hotel in Tryon, North Carolina.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("20 March 1935")]), _vm._v(" Publication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Taps at Reveille,")]), _vm._v(" FSF’s fourth short-story collection.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("May 1935")]), _vm._v(" FSF spends summer at Grove Park Inn, Asheville, North Carolina.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("September 1935")]), _vm._v(" FSF takes apartment at Cambridge Arms, Charles Street, Baltimore.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("November 1935")]), _vm._v(" FSF at Skyland Hotel in Hendersonville, North Carolina; begins writing “The Crack-Up” essays.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("February-April 1936")]), _vm._v(" “The Crack-Up” essays published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Esquire.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8 April 1936")]), _vm._v(" ZF enters Highland Hospital in Asheville.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("July-December 1936")]), _vm._v(" FSF returns to Grove Park Inn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("August 1936")]), _vm._v(" Hemingway’s “The Snows of Kilimanjaro”—with its reference to “poor Scott Fitzgerald”—is published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Esquire,")]), _vm._v(" which includes in the same issue FSF’s “Afternoon of an Author.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('a', {
    attrs: {
      "id": "page_xxix"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("September 1936")]), _vm._v(" Death of Mollie McQuillan Fitzgerald in Washington. Scottie enters Ethel Walker School in Connecticut.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("January-June 1937")]), _vm._v(" FSF returns to Oak Hall Hotel in Tryon, North Carolina.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6 March 1937")]), _vm._v(" ‘“Trouble,”’ FSF’s last story in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Saturday Evening Post,")]), _vm._v(" is published.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("July 1937")]), _vm._v(" Deeply in debt, FSF goes to Hollywood for third time with six-month M-G-M contract at $1,000 a week. Lives at Garden of Allah on Sunset Boulevard; meets Sheilah Graham 14 July.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("July 1937–February 1938")]), _vm._v(" FSF works on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Three Comrades")]), _vm._v(" script, his only screen credit.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("First week of September 1937")]), _vm._v(" FSF visits ZF in Asheville; they spend four days in Charleston and Myrtle Beach, South Carolina.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("December 1937")]), _vm._v(" M-G-M contract renewed for one year at $1,250 a week.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("February 1938–January 1939")]), _vm._v(" FSF works on scripts for “Infidelity,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Marie Antoinette, The Women,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Madame Curie.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("End of March 1938")]), _vm._v(" Fitzgeralds spend Easter at Virginia Beach, Virginia.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("April 1938")]), _vm._v(" FSF rents bungalow at Malibu Beach, California.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("September 1938")]), _vm._v(" Scottie enters Vassar College.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("November 1938")]), _vm._v(" FSF moves to cottage at “Belly Acres,” Encino.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("December 1938")]), _vm._v(" FSF’s M-G-M contract not renewed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("January 1939")]), _vm._v(" FSF works briefly on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gone with the Wind.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("10–12 February 1939")]), _vm._v(" FSF travels to Dartmouth College with Budd Schulberg to work on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Winter Carnival;")]), _vm._v(" fired for drunkenness; hospitalized in New York.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("March 1939–October 1940")]), _vm._v(" FSF takes free-lance jobs at Paramount, Universal, Twentieth Century-Fox, Goldwyn, and Columbia studios.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("April 1939")]), _vm._v(" Fitzgeralds travel to Cuba. FSF goes on bender; hospitalized on return to New York.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("July 1939")]), _vm._v(" FSF breaks with Harold Ober.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Summer 1939")]), _vm._v(" FSF begins work on his Hollywood novel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("September 1939")]), _vm._v(" FSF attempts to sell novel serial rights to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Collier’s.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("January 1940")]), _vm._v(" Publication of “Pat Hobby’s Christmas Wish” in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Esquire,")]), _vm._v(" first of seventeen-story series.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("March-August 1940")]), _vm._v(" FSF works on “Cosmopolitan” (“Babylon Revisited”) script.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ca. 15 April 1940")]), _vm._v(" ZF discharged from Highland Hospital; lives with her mother at 322 Sayre Street in Montgomery.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("May 1940")]), _vm._v(" FSF moves to 1403 North Laurel Avenue, Hollywood.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("21 December 1940")]), _vm._v(" FSF dies of heart attack at Sheilah Graham’s apartment, 1443 North Hayworth Avenue, Hollywood.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('a', {
    attrs: {
      "id": "page_xxx"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("27 December 1940")]), _vm._v(" FSF buried in Rockville Union Cemetery, Rockville, Maryland.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("27 October 1941")]), _vm._v(" Publication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Last Tycoon.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("12 August 1945")]), _vm._v(" Publication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Crack-Up.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("September 1945")]), _vm._v(" Publication of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Portable F. Scott Fitzgerald.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("November 1947")]), _vm._v(" ZF returns to Highland Hospital from Montgomery.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("10 March 1948")]), _vm._v(" ZF dies in fire at Highland Hospital.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("17 March 1948")]), _vm._v(" ZF buried with FSF.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("18 November 1950")]), _vm._v(" Scottie Fitzgerald Lanahan donates the Fitzgerald Papers to Princeton University.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7 November 1975")]), _vm._v(" FSF and ZF reinterred in the Fitzgerald family plot at St. Mary’s Church, Rockville, Maryland.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-f"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("18 June 1986")]), _vm._v(" Scottie Fitzgerald Lanahan Smith dies; she is buried with her parents.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a37dea28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Chronology.vue
// module id = 84
// module chunks = 0